import { render, staticRenderFns } from "./FormWizardIconTabRegister.vue?vue&type=template&id=01a86c89"
import script from "./FormWizardIconTabRegister.vue?vue&type=script&lang=js"
export * from "./FormWizardIconTabRegister.vue?vue&type=script&lang=js"
import style0 from "./FormWizardIconTabRegister.vue?vue&type=style&index=0&id=01a86c89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports